module.exports = __webpack_public_path__ + "static/img/tupian.58efe584.svg";